import type { Referral, ReferralEvent } from "@/types/api";
import { request } from "./transport";

export interface ReferralInput {
  code?: string;
  active?: boolean;
}

export const referrals = {
  lookupReferral: (code: string) =>
    request<{ valid: boolean; affiliate: boolean }>("/referral", {
      method: "POST",
      body: JSON.stringify({ code }),
    }),

  listReferrals: (params?: { active?: boolean }) => {
    const qs = new URLSearchParams();
    if (params?.active !== undefined) qs.set("active", String(params.active));
    const q = qs.toString();
    return request<{ referrals: Referral[] }>(`/referrals${q ? `?${q}` : ""}`);
  },

  createReferral: (input: ReferralInput) =>
    request<{ referral: Referral }>("/referrals", {
      method: "POST",
      body: JSON.stringify({ referral: input }),
    }),

  updateReferral: (id: string, patch: ReferralInput) =>
    request<{ referral: Referral }>(`/referrals/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ referral: patch }),
    }),

  deleteReferral: (id: string) =>
    request<{ ok: true }>(`/referrals/${id}`, { method: "DELETE" }),

  listReferralEvents: (params?: { referral_id?: string }) => {
    const qs = new URLSearchParams();
    if (params?.referral_id) qs.set("referral_id", params.referral_id);
    const q = qs.toString();
    return request<{ referral_events: ReferralEvent[] }>(
      `/referral_events${q ? `?${q}` : ""}`,
    );
  },
};
